<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <upload-document-status-choices-list-filter
      @edit="editComponentFilters($event, 'filter__status')"
      @clean="cleanComponentFilters(['filter__status'])"
    />
    <upload-document-is-optional-list-filter
      @edit="editComponentFilters($event, 'filter__is_optional')"
      @clean="cleanComponentFilters(['filter__is_optional'])"
    />
    <organization-list-filter
      v-if="yard"
      @edit="editComponentFilters($event, 'filter__organization__in')"
      @clean="cleanComponentFilters(['filter__organization__in'])"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as ORG_UPLOAD_DOCUMENT_TYPES } from './store'
import CommonFiltersMixin from '../../../common-filters/CommonFiltersMixin'

export default {
  name: 'OrganizationUploadDocumentCommonFilters',
  props: {
    organization: {},
    yard: {},
    cntId: {}
  },
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: ORG_UPLOAD_DOCUMENT_TYPES.GENERIC.document.organizationuploaddocument.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...ORG_UPLOAD_DOCUMENT_TYPES.GENERIC.document.organizationuploaddocument.LIST.ACTIONS
    })
  }
}
</script>
